<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>
        lblSendNotification
        <span class="font16 ml-3 text-light float-none" *ngIf="customerDetails.customerNo">
            #{{customerDetails.customerNo}} - {{customerDetails.customerName}}
        </span>
        <span class="font16 ml-3 text-light float-none" *ngIf="!customerDetails.customerNo">
            {{customerDetails.customerName}}
        </span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
        <span aria-hidden="true">
            ×
        </span>
    </button>
</div>
<div class="modal-body">
    <form class="popup-vcenter" name="notificationForm" #f="ngForm">
        <div class="row">
            <div class="col col-2">
                <div class="form-group">
                    <label for="channelType" translate>lblChannel</label>
                    <select class="form-control" id="channelType" name="ChannelType" aria-describedby="Select"
                        [(ngModel)]="notificationModel.ChannelType" (ngModelChange)="onChannelChange($event)"
                        #channelType="ngModel">
                        <option *ngFor="let channel of lstChannelType" [value]="channel.id" translate>
                            {{channel.label}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col col-3">
                <div class="form-group">
                    <label for="customerMobileNo" translate>lblMobile</label>
                    <div class="lbl-info">                        
                        <ngx-intl-tel-input [selectFirstCountry]= "false" name="CustomerMobileNo" id="customerMobileNo"
                        [cssClass]="{'form-control': true}"
                        [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false"
                        [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true" 
                        (ngModelChange)="ValidateFields()" [(ngModel)]="notificationModel.CustomerMobileNo"
                        [customPlaceholder]=" 'lblPhoneNumber' | translate "
                        (countryChange)="onCountryChange($event)" #customerMobileNo="ngModel" 
                        ></ngx-intl-tel-input>
                    </div>
                </div>
            </div>
            <div class="col col-4">
                <div class="form-group">
                    <label for="customerEmail" translate>lblEmail</label>
                    <input type="email" id="customerEmail" name="CustomerEmail"
                        [(ngModel)]="notificationModel.CustomerEmail" class="form-control"
                        #customerEmail="ngModel" (ngModelChange)="ValidateFields()" />
                </div>
            </div>
            <div class="form-group">
                    <label for="Language" translate>lblLanguage</label>
                    <ng-select [items]="languageList" bindLabel="value" bindValue="key" placeholder="Select Language"
                        (change)="onLanguageChange()" [(ngModel)]="selectedLanguage" [clearable]="false" [searchable]="false">
                        <ng-template ng-label-tmp let-item="item">
                            <img height="15" width="20" [src]="getFlagImage(item.flagName)" alt="" />
                            <strong class="lang">{{item.value}}</strong>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            <img height="15" width="20" [src]="getFlagImage(item.flagName)" alt="" />
                            <strong class="lang">{{item.value}}</strong>
                        </ng-template>
                    </ng-select>
                </div>
            <div class="col col-4">
                <div class="form-group">
                    <label for="Channel1" translate>lblTemplate</label>
                    <ng-select [items]="templateListFiltered" bindLabel="value" bindValue="template.id" placeholder="Select template"
                        (change)="onTemplateChange($event.id)"  [clearable]="true" [searchable]="false" [(ngModel)]="selectedTemplateId" (clear)="onTemplateClear()">
                        <ng-template ng-label-tmp let-item="item">
                             {{getSectionName(item.applicationId)}} - {{item.name}}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-index="index">                           
                             {{getSectionName(item.applicationId)}} - {{item.name}}
                        </ng-template>
                    </ng-select>                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col col-12" *ngIf="notificationModel.ChannelType != channel.SMS">
                <div class="form-group">
                    <label for="subject" translate>lblSubject</label>
                    <textarea class="form-control" id="subject" name="Subject"
                        [(ngModel)]="notificationModel.Subject" (ngModelChange)="ValidateFields()"
                        #subject="ngModel">
                        </textarea>
                </div>
            </div>
            <div class="col col-12">
                <div class="form-group">
                    <label for="body" translate>lblBody</label>
                    <quill-editor format= "html" id="body" name="Body" [(ngModel)]="notificationModel.Body" [modules]="options" 
                    (ngModelChange)="ValidateFields()" #body="ngModel" 
                    *ngIf="notificationModel.ChannelType != channel.SMS && notificationModel.ChannelType != channel.PushNotification"
                    required></quill-editor>
                    <textarea name="Body" id="body" [(ngModel)]="notificationModel.Body"
                        class="form-control mb-2" (ngModelChange)="ValidateFields()" rows="8" #body="ngModel"
                        *ngIf="notificationModel.ChannelType == channel.SMS || notificationModel.ChannelType == channel.PushNotification"
                        required></textarea>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer justify-content-between">
    <div class="ml-auto">
        <button type="button" class="btn btn-primary mr-sm-2" [disabled]="!isSaveEnable" translate
            (click)="SendNotification()">
            <em class="fas fa-paper-plane"></em> lblSendNotification
        </button>
        <button type="button" class="btn btn-secondary" (click)="OnClose()" translate>
            <em class="far fa-times-circle"></em> lblCancel
        </button>
    </div>
</div>